import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import SendSmsForm from './SendSmsForm';


class SmsDialog extends PureComponent {
    render() {
        const {
            open,
            cancel,
            title,
            templatesFieldName = 'notesSmsTemplates'
        } = this.props;

        return (
            <SendSmsForm templatesFieldName={templatesFieldName}
                         renderTemplateLoad={false}
                         onSmsSent={this.props.cancel}
                         initialTemplate={this.props.initialTemplate}
                         initialEmail={this.props.initialEmail}
                         showAsDialog
                         open={open}
                         cancel={cancel}
                         title={title}
            />
        );
    }
}

SmsDialog.propTypes = {
    title: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    cancel: PropTypes.func.isRequired,
};


export default SmsDialog;